import React from 'react';
import './Navbar.css';
import logo from '../../assets/images/styx-logo.png';

function Navbar() {
  return (
    <header className="site-header" role="banner">
      <div className="container nav-inner">
        <a href="#home" className="brand" aria-label="Styx home">
          <img src={logo} alt="Styx logo" className="brand-logo" />
        </a>
        <nav aria-label="Primary navigation">
          <ul className="nav-list">
            <li><a href="#about">About</a></li>
            <li><a href="#science">Science</a></li>
            <li><a href="#pipeline">Pipeline</a></li>
            <li><a href="#team">Team</a></li>
            <li><a href="#partners">Partners</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;

